/**
 * Race a promise against a timeout. Useful for guarding awaits whose underlying
 * transport may hang silently (e.g. SDK calls behind a throttler/proxy where
 * lower-level timeouts don't propagate). The returned promise rejects with a
 * labeled Error if the timeout fires first.
 */
export const withTimeout = <T>(promise: Promise<T>, timeoutMs: number, label?: string): Promise<T> => {
  if (!timeoutMs) {
    return promise;
  }
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error(label ? `${label} timed out after ${timeoutMs}ms` : `Timeout after ${timeoutMs}ms`));
    }, timeoutMs);
  });
  return Promise.race([promise, timeout]).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });
};
